<button [iconButton]="'filled'"
        [status]="status"
        [icon]="inWishlist ? 'wishlist-fill' : 'wishlist'"
        (click)="toggle()"
        cy-wishlistaddbutton
        class="inline-flex"></button>